// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xdMBv","content":"styles_content__20eYc","row":"styles_row__1nv63","footer":"styles_footer__ya4mp","phraseLength":"styles_phraseLength__1Z8no"};